import React, { useState, useEffect } from 'react';
import axios from 'axios';

// 📤 Share an EOI: booking details + a secure 24-hour link (PIN = last 4 digits of
// the client's mobile) to view the EOI form and cheque. Sent by hand from your phone.
const EOIShare = ({ apiBase, eoiId, onClose }) => {
  const [d, setD] = useState(null);
  const [err, setErr] = useState('');
  const [copied, setCopied] = useState(false);
  useEffect(() => {
    axios.post(`${apiBase}/public-eoi/view-links`, { eoi_id: eoiId }).then((r) => setD(r.data))
      .catch((e) => setErr(e.response?.data?.error || 'Could not create the link.'));
  }, [apiBase, eoiId]);
  const btn = { display: 'block', width: '100%', padding: '14px', borderRadius: '12px', border: 'none', fontSize: '17px', fontWeight: 800, cursor: 'pointer', marginTop: '10px', textAlign: 'center', textDecoration: 'none' };
  const copy = () => navigator.clipboard?.writeText(d.message).then(() => { setCopied(true); setTimeout(() => setCopied(false), 2500); });
  return (
    <div onClick={onClose} style={{ position: 'fixed', inset: 0, background: 'rgba(17,24,39,.55)', zIndex: 1100, display: 'flex', alignItems: 'flex-start', justifyContent: 'center', padding: '40px 12px', overflowY: 'auto' }}>
      <div onClick={(e) => e.stopPropagation()} style={{ background: '#fff', borderRadius: '16px', width: '100%', maxWidth: '480px', padding: '20px' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <h2 style={{ margin: 0, fontSize: '20px', fontWeight: 800 }}>📤 Share EOI</h2>
          <button onClick={onClose} style={{ border: 'none', background: 'none', fontSize: '28px', cursor: 'pointer', color: '#6b7280' }} aria-label="Close">×</button>
        </div>
        <div style={{ fontSize: '14px', color: '#6b7280', marginTop: '4px' }}>Secure link · works for 24 hours · opens with a PIN (last 4 digits of the client's mobile).</div>
        {!d && !err && <div style={{ padding: '16px 0', color: '#6b7280' }}>Creating the secure link…</div>}
        {d && (
          <>
            <div style={{ background: '#dcf8c6', borderRadius: '10px', padding: '12px', fontSize: '14px', whiteSpace: 'pre-wrap', marginTop: '14px', wordBreak: 'break-word' }}>{d.message}</div>
            <a style={{ ...btn, background: '#25D366', color: '#fff' }} target="_blank" rel="noreferrer" href={`https://wa.me/?text=${encodeURIComponent(d.message)}`}>Share on WhatsApp (choose who)</a>
            {d.share_to && <a style={{ ...btn, background: '#fff', color: '#15803d', border: '1.5px solid #86efac' }} target="_blank" rel="noreferrer" href={`https://wa.me/91${d.share_to}?text=${encodeURIComponent(d.message)}`}>Send to the client</a>}
            <button style={{ ...btn, background: '#fff', border: '1px solid #d1d5db', color: '#111827', fontWeight: 700 }} onClick={copy}>{copied ? '✓ Copied' : 'Copy message'}</button>
            <div style={{ fontSize: '12px', color: '#9ca3af', textAlign: 'center', marginTop: '8px' }}>WhatsApp opens on your phone — you press send.</div>
          </>
        )}
        {err && <div style={{ background: '#fef2f2', color: '#b91c1c', padding: '10px 12px', borderRadius: '10px', fontSize: '14px', marginTop: '10px' }}>{err}</div>}
      </div>
    </div>
  );
};

export default EOIShare;
